import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAsanaComponent } from './simple-icons-asana.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAsanaComponent ],
    exports:      [ SimpleIconsAsanaComponent ],
    bootstrap:    []
})
export class SimpleIconsAsanaModule {}
